import { WindowRef } from '@trademe/tangram';

const PING_REDIRECT_PARAM = 'psd';

// written into the querystring parameter paymentSessionData as a base64 encoded chunk
export interface ICreditCardRedirectData {
    returnTo: string;
    customisation?: ICreditCardRedirectCustomisations;
    queryStringParams: Array<[string, string]> | undefined;
    widgetState?: any;
    customState?: any;
}

export interface ICreditCardRedirectCustomisations {
    hideSaveForLater?: boolean;
    previousStepTitle?: string;
    nextStepTitle?: string;
    addCardButtonText?: string;
    simplifiedHeader?: boolean;
    userAvatarLetter?: string;
    userAvatarStyleNumber?: number;
    userIconUrl?: string;
}

// retrieved from the querystring parameter paymentSessionData as a base64 encoded chunk
export interface ICreditCardRedirectResponseData {
    creditCardId?: number;
    widgetState?: any;
    customState?: any;
}

export function ExtractCreditCardRedirectResponseData(wr: WindowRef): ICreditCardRedirectResponseData | undefined {
    function base64UrlDecode(input: string): string {
        // Convert the URL-safe Base64 to standard Base64
        const base64 = input
            .replace(/-/g, '+') // Replace - with +
            .replace(/_/g, '/'); // Replace _ with /

        // Add padding back if needed
        const padLength = base64.length % 4 === 0 ? 0 : 4 - (base64.length % 4);
        const paddedBase64 = base64 + '='.repeat(padLength);

        // Decode the padded Base64 string using atob
        return atob(paddedBase64);
    }

    const result = wr.useWindow(w => {
        const queryStringParams = new URLSearchParams(w.location.search);
        let redirectResponseData: ICreditCardRedirectResponseData | undefined = undefined;

        if (queryStringParams.has(PING_REDIRECT_PARAM)) {
            try {
                const paymentSessionData = decodeURI(queryStringParams.get(PING_REDIRECT_PARAM));
                const jsonString = base64UrlDecode(paymentSessionData);
                redirectResponseData = JSON.parse(jsonString) as ICreditCardRedirectResponseData;
            } catch {
                redirectResponseData = undefined;
            }
        }

        return redirectResponseData;
    });

    if (result === null) {
        return undefined;
    }

    return result;
}

export function ClearCreditCardRedirectResponseDataParam(wr: WindowRef) {
    wr.useWindow(window => {
        const url = new URL(window.location.href);
        url.searchParams.delete('psd');
        window.history.replaceState(window.history.state, '', url.href);
    });
}
